export default "__VITE_ASSET__B0nV58Gl__"